/** Feature flags — flip to re-enable UI without code archaeology. */
export const FEATURE_REPORTS_ENABLED = true;
export const FEATURE_WAREHOUSE_ENABLED = true;
